import axios from 'axios';
import { post } from './client';

export function getSoilCsvUploadUrl(growerId, fileName) {
  return post(`/soil/upload/${growerId}/get-signed-upload-url`, {
    fileName,
  });
}

export function uploadSoilToS3(signedUrl, file, onProgress) {
  return axios.put(signedUrl, file, {
    headers: { 'Content-Type': 'text/csv' },
    onUploadProgress: (progressEvent) => onProgress(file.name, progressEvent),
  });
}

export function sendSoilDataToProcessingQueue(fileNames) {
  return post('/soil/upload', { fileNames });
}
